import { ICrud } from "../index";
import { ServiceCaller } from "../../../../libs/service-caller";

const _serviceCaller = new ServiceCaller(process.env.VUE_APP_API);

export class BasicCrud extends ICrud {
    constructor() {
        super();
    }

    async query(action, request, queryParams) {
        let query_response = await callService(action, request, queryParams);
        return query_response;
    }

    async getAll(action, request, queryParams) {
        let get_all_response = await callService(action, request, queryParams);
        return get_all_response;
    }

    async getById(action, request, queryParams) {
        let get_by_id_response = await callService(action, request, queryParams);
        return get_by_id_response;
    }

    async create(action, request, queryParams) {
        let create_all_response = await callService(action, request, queryParams);
        return create_all_response;
    }

    async update(action, request, queryParams) {
        let update_response = await callService(action, request, queryParams);
        return update_response;
    }

    async delete(action, request, queryParams) {
        let delete_response = await callService(action, request, queryParams);
        return delete_response;
    }
}

async function callService(action, request, queryParams = "") {
    let response = await _serviceCaller.call(action.method, `${action.domain}/${action.action}${queryParams}`, request);
    return response;
}